import React from 'react'
import { useAuth } from '../contexts/AuthContext'
import HeadOfAcquisitionDashboard from './dashboard/HeadOfAcquisitionDashboard'
import BDExecutiveDashboard from './dashboard/BDExecutiveDashboard';

const Dashboard = () => {
  const { user } = useAuth()

  // Render role-specific dashboard
  if (user?.role?.level === 3) {
    // Head of Acquisition
    return <HeadOfAcquisitionDashboard />
  }

  if (user?.role?.level === 4) {
    // BD Executive
    return <BDExecutiveDashboard />
  }

  // Default dashboard for other roles
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
        <p className="mt-1 text-sm text-gray-600">
          Welcome to WTF Gym Acquisition System
        </p>
      </div>

      <div className="bg-white overflow-hidden shadow rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Welcome, {user?.name}
          </h3>
          <div className="mt-2 max-w-xl text-sm text-gray-500">
            <p>
              You are logged in as a {user?.role?.name}. Use the navigation above to access your tools.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dashboard 